import * as React from 'react';
import { Datagrid, List, TextField } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { IndexField } from '../../components/IndexField';
import { ListActions } from '../../components/ListAction';
import { ListIsEmptyPage } from '../../components/ListIsEmptyPage';

export const DateList = (props: unknown) => (
  <List sort={{ field: 'date', order: 'DESC' }} empty={<ListIsEmptyPage />} actions={<ListActions />} title={<CustomTitle />} {...props}>
    <Datagrid rowClick="edit">
      <IndexField label="#" sortable={false} />
      <TextField source="date" />
      <TextField source="firstSessionStart" />
      <TextField source="lastSessionEnd" />
      <TextField source="id" />
    </Datagrid>
  </List>
);
